import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField
} from "@mui/material";

export interface CreateForecastPeriodDialogProps {
    open: boolean;
    currentForecastPeriodName: string;
    newForecastPeriodName: string;
    validationError: string;
    isCreating: boolean;
    onNameChange: (value: string) => void;
    onClose: () => void;
    onSubmit: () => void;
}

const CreateForecastPeriodDialog: React.FC<CreateForecastPeriodDialogProps> = ({
    open,
    currentForecastPeriodName,
    newForecastPeriodName,
    validationError,
    isCreating,
    onNameChange,
    onClose,
    onSubmit
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            disableEscapeKeyDown={isCreating}
        >
            <DialogTitle>Create Forecast Period</DialogTitle>
            <DialogContent>
                <p>
                    Are you sure you wish to create the next forecast period? The current forecast period{" "}
                    <strong>{currentForecastPeriodName}</strong> will be locked. This action cannot be undone.
                </p>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Forecast Period Name"
                    fullWidth
                    value={newForecastPeriodName}
                    onChange={(e) => onNameChange(e.target.value)}
                    error={!!validationError}
                    helperText={validationError}
                    disabled={isCreating}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary" disabled={isCreating}>
                    Cancel
                </Button>
                <Button onClick={onSubmit} color="primary" disabled={isCreating}>
                    {isCreating ? "Creating..." : "Create"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateForecastPeriodDialog;

